import { IUser, User } from '../models/user';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, take } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';

export interface UserServiceConfig {
  baseUrl: string;
}

export const USER_SERVICE_CONFIG = 'USER_SERVICE_CONFIG';

@Injectable()
export class UserService {
  private _users = new BehaviorSubject<User[]>([]);
  public users$ = this._users.asObservable();

  constructor(
    private httpClient: HttpClient,
    @Inject(USER_SERVICE_CONFIG) private config: UserServiceConfig
  ) {}

  createUser(user: User): Observable<User> {
    return this.httpClient.post('', user).pipe(
      map((response: any) => {
        return User.createUser(response as IUser, response.id);
      })
    );
  }

  /**
   * Fetches all users from the API and updates the users$ observable.
   * Filters out system user (id = 0) and sorts by first name.
   * Uses same endpoint as KeyingAuthService.getUsers()
   */
  getAllUsers(): void {
    // baseUrl already includes /v1 (e.g., https://api.com/v1)
    const url = `${this.config.baseUrl}/Users`;
    this.httpClient
      .get<any[]>(url)
      .pipe(
        take(1),
        map((users: any[]) =>
          users
            .map((u) => User.createUser(u as IUser, u.id))
            .filter(user => user.id !== 0)
            .sort((a, b) => a.firstName.localeCompare(b.firstName))
        )
      )
      .subscribe((users: User[]) => {
        this._users.next(users);
      });
  }
}
